import {type Module} from 'vuex';
import actions from './actions';
import mutations from './mutations';

// state
const state: ModuleGalleryState = {
    count: 0,
    lastUpdate: 0,
    categories: {},
    zipDownloadAllowed: false,
    listViewCover: false,
    admin: false,
    canCreate: false,
};

// module
const gallery: Module<ModuleGalleryState, RootState> = {
    namespaced: true,
    state,
    actions,
    mutations,
};

export default gallery;